module.exports = __webpack_public_path__ + "static/deals-for-you-main-e29bccf6d5ee325b7fd16a4e99c28910.png";